import { Card } from "../components/ui/card";
import { FaWallet, FaChartLine, FaCube } from "react-icons/fa";

export default function BalanceCard({ balance, optionsOwned, estimatedWeeklyGain }) {
  const coinzToUSD = (coinz) => (coinz * 0.00001).toFixed(4); // Conversion avec 4 décimales

return (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
    <Card className="bg-gray-800/50 p-4 flex items-center gap-4">
      <FaWallet className="text-yellow-400 text-2xl" />
      <div>
        <p className="text-sm text-gray-400">Balance</p>
        <p className="text-lg font-semibold">{balance} COINZ</p>
        <p className="text-xs text-gray-400">${coinzToUSD(balance)} USD</p>
      </div>
    </Card>

    <Card className="bg-gray-800/50 p-4 flex items-center gap-4">
      <FaCube className="text-blue-400 text-2xl" />
      <div>
        <p className="text-sm text-gray-400">Options Owned</p>
        <p className="text-lg font-semibold">{optionsOwned}</p>
        {/* If you want to convert options to dollars, you can add logic here */}
      </div>
    </Card>

    <Card className="bg-gray-800/50 p-4 flex items-center gap-4">
      <FaChartLine className="text-green-400 text-2xl" />
      <div>
        <p className="text-sm text-gray-400">Estimated Gain / Week</p>
        <p className="text-lg font-semibold">{estimatedWeeklyGain} COINZ</p>
        <p className="text-xs text-gray-400">${coinzToUSD(estimatedWeeklyGain)} USD</p>
      </div>
    </Card>
  </div>
);
}
